import styled from 'styled-components';
import { MediaBreakpoints, spacing } from '../helpers/theme.helpers';

interface FlexBoxProps {
  flexType: 'container' | 'item';
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  wrap?: 'wrap' | 'no-wrap';
  justify?: 'space-between' | 'space-around' | 'space-evenly' | 'center' | 'flex-start' | 'flex-end';
  align?: 'stretch' | 'flex-start' | 'center' | 'flex-end';
  grow?: number;
  shrink?: number;
  basis?: string;
  gap?: number | string;
  padding?: string;
  overflow?: string;
}

export const FlexBox = styled.div<FlexBoxProps>`
  display: flex;
  ${({ gap }) => (gap ? `gap: ${typeof gap === 'string' ? gap : spacing(gap)};` : '')}
  ${({ flexType, direction, wrap, justify, align, grow, shrink, basis, padding, overflow }: FlexBoxProps) => {
    switch (flexType) {
      case 'container':
        return `
          ${direction ? `flex-direction: ${direction};` : ''}
          ${wrap ? `flex-wrap: ${wrap};` : ''}
          ${justify ? `justify-content: ${justify};` : ''}
          ${align ? `align-items: ${align};` : ''}
          ${grow ? `flex-grow: ${grow};` : ''}
        `;

      case 'item':
        return `
          ${grow ? `flex-grow: ${grow};` : ''}
          ${shrink ? `flex-shrink: ${shrink};` : ''}
          ${basis ? `flex-basis: ${basis};` : ''}
          ${align ? `align-self: ${align};` : ''}
          ${padding ? `padding: ${padding};` : ''}
          ${justify ? `justify-content: ${justify};` : ''}
          ${overflow ? `overflow: ${overflow} !important;` : ''}
          `;
    }
  }}
  ${MediaBreakpoints.down('md')} {
    ${({ flexType, justify }: FlexBoxProps) => {
      switch (flexType) {
        case 'container':
          return '';

        case 'item':
          return `
            ${justify ? 'justify-content: flex-end;' : ''}
        `;
      }
    }}
  }
`;
